import { Controller } from "@hotwired/stimulus"

// Wraps the Permissions card and drives all permission-category sections at
// once. Single button toggles between collapsing and expanding every category.
export default class extends Controller {
  static outlets = ["identity--permission-category"]
  static targets = ["label"]

  toggleAll() {
    const categories = this.identityPermissionCategoryOutlets
    const anyOpen = categories.some((c) => c.isOpen())

    categories.forEach((c) => (anyOpen ? c.collapse() : c.expand()))

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = anyOpen ? "Expand all" : "Collapse all"
    }
  }
}
